import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 'erp-system',
    title: 'Enterprise Resource Planning System',
    outcome: 'Increased operational efficiency by 40% and reduced processing time by 60%',
    technologies: ['React', 'Node.js', 'PostgreSQL', 'AWS'],
  },
  {
    id: 'saas-platform',
    title: 'Multi-tenant SaaS Platform',
    outcome: 'Scaled to support 10,000+ users with 99.9% uptime',
    technologies: ['Vue.js', 'Python', 'Docker', 'Kubernetes'],
  },
  {
    id: 'network-overhaul',
    title: 'Network Infrastructure Overhaul',
    outcome: 'Enhanced security posture and improved network performance by 300%',
    technologies: ['Cisco', 'Firewall', 'VPN', 'Monitoring'],
  },
  {
    id: 'ai-analytics',
    title: 'AI-Powered Analytics Dashboard',
    outcome: 'Enabled data-driven decisions with real-time insights and predictive analytics',
    technologies: ['Python', 'TensorFlow', 'D3.js', 'BigQuery'],
  },
]; 